import './Cybercafe.css';
let Cybercafe=()=>{
    let services = ["Pan Card","Aadhar card","Aay-Jati-Nivas", "Ticket Booking", "Voter Id", "PM kissan samman nidhi", "PMKSU", "Ration Card", "Pention Online", "Khatauni Up", "Result Download", "Scholarship Form UP", "Aayushman Bharat Card", "Bill Payments", "Photo Print", "Admit card", "Insurence(Bike, Car, Truck, Tempo...Any kind of vehicle)", "iti Result"];
    let getservicesname=(a)=>{
        if(a === "Pan Card"){
            document.querySelector(".pancard").style.display="block";
        }else{
            document.querySelector(".pancard").style.display="none";
        }

        if(a === "Aadhar card"){
            document.querySelector(".aadharcard").style.display="block";
 
        }else{
            document.querySelector(".aadharcard").style.display="none";

        }

        if(a === "Aay-Jati-Nivas"){
            document.querySelector(".aayjatinivas").style.display="block";

        }else{
            document.querySelector(".aayjatinivas").style.display="none";

        }

         if(a === "Ticket Booking"){
            document.querySelector(".ticketbooking").style.display="block";

        }else{
            document.querySelector(".ticketbooking").style.display="none";

        }

         if(a === "Voter Id"){
            document.querySelector(".voterid").style.display="block";

        }else{
            document.querySelector(".voterid").style.display="none";

        }


         if(a === "PM kissan samman nidhi"){
            document.querySelector(".pmkissansammannidhi").style.display="block";

        }else{
            document.querySelector(".pmkissansammannidhi").style.display="none";

        }


         if(a === "PMKSU"){
            document.querySelector(".PMKSU").style.display="block";

        }else{
            document.querySelector(".PMKSU").style.display="none";

        }

         if(a === "Ration Card"){
            document.querySelector(".Rationcard").style.display="block";

        }else{
            document.querySelector(".Rationcard").style.display="none";

        }

         if(a === "Pention Online"){
            document.querySelector(".pentiononline").style.display="block";

        }else{
            document.querySelector(".pentiononline").style.display="none";

        }






        if(a === "Khatauni Up"){
            document.querySelector(".khatauniup").style.display="block";

        }else{
            document.querySelector(".khatauniup").style.display="none";

        }


        if(a === "Result Download"){
            document.querySelector(".resultdownload").style.display="block";

        }else{
            document.querySelector(".resultdownload").style.display="none";

        }


        if(a === "Scholarship Form UP"){
            document.querySelector(".scholarshipup").style.display="block";

        }else{
            document.querySelector(".scholarshipup").style.display="none";

        }











         if(a === "Aayushman Bharat Card"){
            document.querySelector(".aayushmancard").style.display="block";

        }else{
            document.querySelector(".aayushmancard").style.display="none";

        }



         if(a === "Bill Payments"){
            document.querySelector(".billpayments").style.display="block";

        }else{
            document.querySelector(".billpayments").style.display="none";

        }



         if(a === "Admit card"){
            document.querySelector(".admitcard").style.display="block";

        }else{
            document.querySelector(".admitcard").style.display="none";

        }



         if(a === "Insurence(Bike, Car, Truck, Tempo...Any kind of vehicle)"){
            document.querySelector(".insurence").style.display="block";

        }else{
            document.querySelector(".insurence").style.display="none";

        }


        if(a === "iti Result"){
            document.querySelector(".itiresult").style.display="block";

        }else{
            document.querySelector(".itiresult").style.display="none";

        }
    }
    return(
        <div className='cybercafemaincont'>
            <h3 className='cyberheading'>My-Cyber-Cafe</h3>
            <div className='servsandworkplacecont'>
                <div className='servicescont ssame'>
                    <h3 className='servhead headsm'>Services</h3>   
                    {
                        services.map( 
                            aa=>(  
                                <div className='servscont'>
                                    <p onClick={()=>{getservicesname(aa)}} className='serv'>{aa}</p>
                                </div>
                            )
                        )
                    }
                </div>
                <div className='workplacecont ssame'>
                    {/* <h3 className='headsm'>work place</h3> */}
                    <div style={{display:"none"}} className='pancard smstyl'>
                        <h3 className='panheading'>Pan card Important links</h3>
                        <div className='linkscont'>
                            <span><a href='https://onlineservices.proteantech.in/paam/endUserRegisterContact.html' target='_blank'>Apply for new pan card</a></span>
                            <span><a href='https://onlineservices.proteantech.in/paam/endUserRegisterContact.html' target='_blank'>Correction pan card</a></span>
                            <span><a href='https://onlineservices.proteantech.in/paam/ReprintEPan.html'>Order pan card pvc</a></span>
                            <span><a href='https://eportal.incometax.gov.in/iec/foservices/#/pre-login/instant-e-pan' target='_blank'>Make Instant pan card</a></span>
                            <span><a href='https://eportal.incometax.gov.in/iec/foservices/#/pre-login/instant-e-pan/checkStatusDownloadEpan' target='_blank'>Download Instant pan card</a></span>
                            <span><a href='https://www.pan.utiitsl.com/PAN_ONLINE/ePANCardHome' target='_blank'>Download pan card</a></span>

                        </div>
                    </div>
                     <div style={{display:"none"}} className='aadharcard smstyl'>
                        <h3>Aadhar card Important Links</h3>  
                         <div className='linkscont'>
                            <span><a href='https://myaadhaar.uidai.gov.in/genricDownloadAadhaar/en' target='_blank'>Download Aadhar card</a></span>
                            <span><a href='https://myaadhaar.uidai.gov.in/login' target='_blank'>Login Aadhar</a></span>
                            <span><a href='https://myaadhaar.uidai.gov.in/CheckAadhaarStatus/en' target='_blank'>Check aadhar update status</a></span>
                            <span><a href='https://myaadhaar.uidai.gov.in/genricPVC/en' target='_blank'>Aadhar pvc card apply</a></span>
                            <span><a href='https://myaadhaar.uidai.gov.in/retrieve-eid-uid/en' target='_blank'>Download aadhar card by name</a></span>
                            <span><a href='https://tathya.uidai.gov.in/access/login?role=resident' target='_blank'>Bank seeding status</a></span>

                        </div> 
                    </div>
                     <div style={{display:"none"}} className='aayjatinivas smstyl'>
                        <h3>Make Income, Domecile, Cast For UP</h3>
                        <div className='linkscont'>
                            <span><a href='https://edistrict.up.gov.in/edistrictup/' target='_blank'>Edistrict up</a></span>
                            
                           

                        </div> 
                    </div>
                     <div style={{display:"none"}} className='ticketbooking smstyl'>
                        <h3>Railway Irctc Ticket Booking Important Links</h3>
                          <div className='linkscont'>
                            <span><a href='https://www.irctc.co.in/nget/train-search' target='_blank'>Book Ticket</a></span>
                            
                           

                        </div> 
                    </div>
                    <div style={{display:"none"}} className='voterid smstyl'>
                        <h3>Voter Card Important Links</h3>
                          <div className='linkscont'>
                            <span><a href='https://voters.eci.gov.in/' target='_blank'>Make new voter id</a></span>
                            
                           

                        </div> 
                    </div>

                     <div style={{display:"none"}} className='pmkissansammannidhi smstyl'>
                        <h3>pm kissan samman nidhi yojana Important Links</h3>
                    </div>

                     <div style={{display:"none"}} className='PMKSU smstyl'>
                        <h3>PM Kanya Sumangla Yoana</h3>
                    </div>

                     <div style={{display:"none"}} className='Rationcard smstyl'>
                        <h3>Up Rationcard Important Links</h3>
                    </div>


                    <div style={{display:"none"}} className='pentiononline smstyl'>
                        <h3>Up Pention Links</h3>
                    </div>

                    <div style={{display:"none"}} className='khatauniup smstyl'>
                        <h3>Up Khatauni Links</h3>
                    </div>

                    <div style={{display:"none"}} className='resultdownload smstyl'>
                        <h3>Result Download Links</h3>
                    </div>

                    <div style={{display:"none"}} className='scholarshipup smstyl'>
                        <h3>Up Scholarship Links</h3>
                    </div>

                    <div style={{display:"none"}} className='aayushmancard smstyl'>
                        <h3>Aayushman Bharat Yoana Links</h3>
                    </div>

                    <div style={{display:"none"}} className='billpayments smstyl'>
                        <h3>Pay Bills</h3>
                    </div>

                    <div style={{display:"none"}} className='admitcard smstyl'>
                        <h3>Admit Card Download Links</h3>
                    </div>

                    <div style={{display:"none"}} className='insurence smstyl'>
                        <h3>Make Insurence For Any vehicle</h3>
                    </div>


                     <div style={{display:"none"}} className='itiresult smstyl'>
                        <h3>Iti Result Download Links</h3>
                    </div>
                </div>
            </div>
        </div>
    );
}
 export default Cybercafe;